import React, { useState } from 'react';
import { LimitPromo } from 'shared/components/LimitPromo';
import { RateNumberInputContainer } from '../RateNumberInput';
import { useDeviceType } from '@cian/ui-kit';
import { useApplicationContext } from 'shared/utils/applicationContext';

const LIMIT_VALUES = [100, 200, 300, 500];
const LIMIT_LABEL = 'Лимит на день';

export const LimitPromoContainer: React.FC = () => {
  const { config } = useApplicationContext();

  const [index, setIndex] = useState(0);

  const device = useDeviceType();

  const btnIsDisabled = Boolean(config.get<boolean>('b2b-marketing-cpc-frontend.disableBtnPrices'));

  const handleIndex = (value: number) => {
    setIndex(value);
  };

  const limitValue = LIMIT_VALUES[index];

  return (
    <LimitPromo
      device={device}
      limitValue={limitValue}
      btnPricesIsDisabled={btnIsDisabled}
      numberInput={
        <RateNumberInputContainer values={LIMIT_VALUES} index={index} onIndexChange={handleIndex} label={LIMIT_LABEL} />
      }
    />
  );
};
